module.exports = __webpack_public_path__ + "static/roboto-v20-cyrillic_latin-300-b6e1d0fde881ad6c9a4de81882059be4.woff2";